import { Injectable } from '@angular/core';
import { EnvConfigurationService } from './envconf.service';
import { HttpClient } from '@angular/common/http';
import { StockInventory } from '../models/stockInventory';
import { StockArrival } from '../models/stockArrival';
import { ImportArrivalsResponse } from '../models/importArrivalsResponse';

@Injectable({
  providedIn: 'root'
})
export class StockService {
  endpoint: string = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/stock`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Get stocks for a site
   * @param siteId Site ID
   * @param startYear
   * @param startMonth
   */
  getStockInventories(siteId: number, startYear: number, startMonth: number) {
    return this.http.get<Array<StockInventory>>(`${this.endpoint}?siteId=${siteId}&startYear=${startYear}&startMonth=${startMonth}`);
  }

  /**
   * Save modified stocks for a site
   * @param siteId Site ID
   * @param data Modified stocks data
   * @param currentMonthYear Current date in format YYYY-MM-01
   */
  saveStockInventories(siteId: number, data: Array<StockInventory>, currentMonthYear: string) {
    const stockInventoriesToSave = data.map(({ tireSpec, stocksByMonth }) => ({
      tireSpecId: tireSpec.tireSpecId,
      stock: stocksByMonth[currentMonthYear]
    }));
    return this.http.put(`${this.endpoint}?siteId=${siteId}`, stockInventoriesToSave);
  }

  /**
   * Get stock arrivals for a site
   * @param siteId Site ID
   * @param startYear
   * @param startMonth
   */
  getStockArrivals(siteId: number, startYear: number, startMonth: number) {
    return this.http.get<Array<StockArrival>>(`${this.endpoint}/arrivals?siteId=${siteId}&startYear=${startYear}&startMonth=${startMonth}`);
  }

  /**
   * Save modified stock arrivals for a site
   * @param siteId Site ID
   * @param data Modified stock arrivals data
   */
  saveStockArrivals(siteId: number, data: Array<StockArrival>) {
    let stockArrivalsToSave = data
      .filter((stockArrival) => Object.keys(stockArrival.ongoingDeliveryByMonth).length > 0)
      .map(({ tireSpec, ongoingDeliveryByMonth }) => ({
        tireSpecId: tireSpec.tireSpecId,
        ongoingDeliveries: Object.values(ongoingDeliveryByMonth)
      }));
    return this.http.put(`${this.endpoint}/arrivals?siteId=${siteId}`, stockArrivalsToSave);
  }

  /**
   * Import arrivals file.
   * @param siteId Site ID
   * @param file File to import
   */
  importArrivals(siteId: number, file: File) {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.http.post<ImportArrivalsResponse>(`${this.endpoint}/arrivals/import?siteId=${siteId}`, form);
  }
}
